import { IsolatedScanSystemData } from "../types/types"
import { genericRequest, isolatedScanSystemDataRoute } from "./service"

/**
 * Gets Pi360 system data for a given section.
 * 
 * @param sectionScanId of section scan to get system data for.
 * 
 * @returns isolated scan system data for the section scan.
 */
export const getIsolatedScanSystemData = async (sectionScanId: number): Promise<IsolatedScanSystemData[] | Error> => {
  return await genericRequest({ url: `${isolatedScanSystemDataRoute}/isolated_scan_system_datas/${sectionScanId}`, method: "GET" })
}

/**
 * Create a new isolated scan system data entry in the database.
 * 
 * @param isolatedScanSystemData to add to the database.
 * 
 * @returns created isolated scan system data or an error.
 */
export const addIsolatedScanSystemData = async (isolatedScanSystemData: IsolatedScanSystemData, sectionScanId: number): Promise<IsolatedScanSystemData | Error> => {
  const body = JSON.stringify(isolatedScanSystemData)
  return await genericRequest({ url: `${isolatedScanSystemDataRoute}/${sectionScanId}`, method: "POST", body: body })
}